export const refetchSiteData = (data: any) => ({
  type: "REFETCH_SITE_DATA",
  payload: data,
});
